import { render, staticRenderFns } from "./Reportingfrequency.vue?vue&type=template&id=20804d66&"
import script from "./Reportingfrequency.vue?vue&type=script&lang=js&"
export * from "./Reportingfrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports